import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { Student } from '@/types';
import { YES_NO, TRANSPORTATION_METHODS } from '../../StudentForm/constants';

interface DemographicSectionProps {
  values: Partial<Student>;
  onChange: (id: keyof Student, value: any) => void;
}

export const DemographicSection: React.FC<DemographicSectionProps> = ({
  values,
  onChange
}) => {
  const handleChange = (field: keyof Student) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange(field, event.target.value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Ethnicity"
          value={values.ethnicity || ''}
          onChange={handleChange('ethnicity')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Primary Language"
          value={values.primaryLanguage || ''}
          onChange={handleChange('primaryLanguage')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Secondary Language"
          value={values.secondaryLanguage || ''}
          onChange={handleChange('secondaryLanguage')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Free/Reduced Lunch Eligible"
          value={values.lunchEligibility || ''}
          onChange={handleChange('lunchEligibility')}
        >
          {YES_NO.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Homeless Status"
          value={values.homelessStatus || ''}
          onChange={handleChange('homelessStatus')}
        >
          {YES_NO.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Foster Care Status"
          value={values.fosterCare || ''}
          onChange={handleChange('fosterCare')}
        >
          {YES_NO.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Transportation Method"
          value={values.transportation || ''}
          onChange={handleChange('transportation')}
        >
          {TRANSPORTATION_METHODS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};